import classNames from 'clsx';
import React from 'react';
import type { MdComponentIndexProps } from '../type';
import styles from './Tip.module.less';

function transformBoolean(val: any) {
  if (typeof val === 'boolean') {
    return val;
  }
  if (val === 'true') {
    return true;
  }
  if (val === 'false') {
    return false;
  }
  return undefined;
}

export function MarkdownTipBad(
  props: React.PropsWithChildren<
    {
      border?: boolean;
    } & MdComponentIndexProps
  >,
) {
  const border = transformBoolean(props.border) ?? true;
  return (
    <div
      className={classNames(styles.TipContainer, styles.TipContainerShowLine)}
      data-first={props['data-first']}
      data-last={props['data-last']}
    >
      <div className="flex items-center pl-1">
        <div className="relative mr-4 w-4 h-4 rounded-full text-white flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            style={{
              scale: 'calc(24 / 20)',
              marginBottom: 2,
            }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM13.3701 6.6299C13.7251 6.98493 13.7251 7.56053 13.3701 7.91555L11.2856 10L13.3701 12.0844C13.7251 12.4395 13.7251 13.0151 13.3701 13.3701C13.0151 13.7251 12.4395 13.7251 12.0844 13.3701L10 11.2856L7.91555 13.3701C7.56053 13.7251 6.98493 13.7251 6.6299 13.3701C6.27488 13.0151 6.27488 12.4395 6.6299 12.0844L8.71435 10L6.6299 7.91555C6.27488 7.56053 6.27488 6.98493 6.6299 6.6299C6.98493 6.27488 7.56053 6.27488 7.91555 6.6299L10 8.71435L12.0844 6.6299C12.4395 6.27488 13.0151 6.27488 13.3701 6.6299Z"
              fill="var(--ui-red-6)"
            />
          </svg>
          {border ? (
            <div
              className={classNames('absolute top-full mt-1 rounded-full', styles.TipLine)}
              style={{
                width: 1,
                backgroundColor: `var(--ui-red-2)`,
                height: `calc(var(--markdown-x-component-gap) + 0px)`, // 16px
                top: `calc(var(--markdown-x-component-gap) + 1px)`, // 16px + 2px
                left: `0.46875rem`,
              }}
            />
          ) : null}
        </div>
        <div className="m-0 flex-1 text-base font-semibold text-slate-900 dark:text-slate-200 markdown-child-root">
          {props.children}
        </div>
      </div>
    </div>
  );
}

MarkdownTipBad.attributes = ['border'] as string[];
